import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// SVGS
import {
  Check,
  Dog,
  Chart,
  GreenMoneyBag,
  OrangeMoneyBag,
  Rabbit,
  Turtle,
  SnowflakeCool,
  LightBulb,
  HomebotIcon,
} from '../Svg'

// Styles
import styles from './CircleIcon.module.scss'

const BACKGROUND_COLORS = ['success', 'warning', 'danger', 'none']

const ICONS = [
  'dog',
  'lightBulb',
  'rabbit',
  'turtle',
  'snowflakeCool',
  'greenMoneyBag',
  'orangeMoneyBag',
  'check',
  'chart',
  'homebot',
]

const propTypes = {
  backgroundColor: PropTypes.oneOf(BACKGROUND_COLORS).isRequired,
  icon: PropTypes.oneOf(ICONS).isRequired,
  className: PropTypes.string,
}

const CircleIcon = ({ backgroundColor, icon, className }) => {
  const iconMapping = {
    dog: <Dog />,
    check: <Check />,
    chart: <Chart />,
    greenMoneyBag: <GreenMoneyBag />,
    lightBulb: <LightBulb />,
    orangeMoneyBag: <OrangeMoneyBag />,
    rabbit: <Rabbit />,
    snowflakeCool: <SnowflakeCool />,
    turtle: <Turtle />,
    homebot: <HomebotIcon />,
  }

  const wrapperClassName = classnames(
    styles.iconWrapper,
    styles[`iconWrapper-${backgroundColor}`],
    className
  )

  return <div className={wrapperClassName}>{iconMapping[icon]}</div>
}

CircleIcon.propTypes = propTypes

CircleIcon.BackgroundColors = BACKGROUND_COLORS
CircleIcon.Icons = ICONS

export default CircleIcon
